import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';

function GroupMaster({adminData}) {
         const [showForm, setShowForm] = useState(false);
   const [chargeMaster, setChargeMaster] = useState([]);
   const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
  const [chargeOptions, setChargeOptions] = useState([]);
    const { setLoading } = useLoading();
  const[hsnCode,setHsnCode] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
const[parent,setParent] = useState([]);
const[allCat,setAllCat] = useState([]);

     const [form, setForm] = useState({
  name: "",
  parent: "",
  hsn_code: "",
  })


     const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  
  const handleAddClick = () => {
    setShowForm(true);
  };

    const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  const sendData = {
    name: form.name,
    parent: form.parent,
    hsn_code:form.hsn_code
     
  };

  try {
    if (isEditMode) {
      await axios.put(
        `https://api.skyguard.group/api/update-master-group/${form.id}`,
        sendData,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      showToast("Group master Updated Successfully!", "success");
    } else {
      await axios.post(
        "https://api.skyguard.group/api/add-master-group",
        sendData,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      showToast("HSN Added Successfully!", "success");
    }

    setShowForm(false);
    setIsEditMode(false);

    fetchHsn();
    fetchAllCat();

resetForm();

  } catch (err) {
    showToast(
      isEditMode
        ? "Failed To Update HSN!"
        : "Failed To Add HSN!",
      "danger"
    );

    console.error(
      "❌ Error:",
      err.response?.data || err.message
    );
  }
};


  const fetchHsn = async () => { 
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-hsn-master');
   setHsnCode(res.data)
  
    } catch (error) {
      console.log(error)
    }
  };

  const hsnOptions = hsnCode.map((item) => ({
  value: item.code, 
  label: item.code  
}));

const fetchParentCat = async () => { 
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-category-master');
   setParent(res.data)

    } catch (error) {
      console.log(error)
    }
  };


  const fetchAllCat = async () => { 
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-all-category');
   setAllCat(res.data)
    } catch (error) {
      console.log(error)
    }
  };


    useEffect(() => {
   fetchHsn();
   fetchParentCat();
   fetchAllCat();
  }, []);

     

const parentOptions = parent.map((item) => ({
  value: item.name,
  label: item.name
}));
  
const handleEdit = (selectedForm) => {

  setForm({
    id: selectedForm.id || "",
    name: selectedForm.name || "",
    parent: selectedForm.parent || "",
      hsn_code: selectedForm.hsn_code || ""
  });



  setEditingCompanyId(selectedForm.id);
  setIsEditMode(true);
  setShowForm(true);
};
  
      const filteredData = allCat.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )


  
  const resetForm = () => {
        setForm({
      code: "",
      parent: ""
    });

  }

  return (
  <>
    <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Item Group Master</h3>

          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">
            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search by Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>


          {showForm && (


            <div className='card p-3 mb-3  w-75 mx-auto'>
              <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">

    <span className="badge bg-primary px-3 py-2">
     {form.name}
    </span>
  </div>
)}

                <hr />

                <div className='row g-3'>

                         <div className="col-md-6">
                    <label htmlFor='middle' className="form-label fw-medium" >Name</label>
                    <input type="text" className="form-control" name="name" placeholder="Enter here..."
                      value={form.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
  <label
    htmlFor="parent"
    className="form-label fw-medium"
  >
    Parent
  </label>

  <Select
    name="parent"
    options={parentOptions}
    placeholder="Select Parent"
    value={
      parentOptions.find(
        (option) => option.value === form.parent
      ) || null
    }
    onChange={(selectedOption) =>
      setForm({
        ...form,
        parent: selectedOption
          ? selectedOption.value
          : ""
      })
    }
  />
</div>

               <div className="col-md-6">
  <label className="form-label fw-medium">
    HSN Code
  </label>

  <Select
    name="hsn_code"
    options={hsnOptions}
    placeholder="Select HSN Code"
    value={
      hsnOptions.find(
        (option) => option.value === form.hsn_code
      ) || null
    }
    onChange={(selectedOption) =>
      setForm({
        ...form,
        hsn_code: selectedOption
          ? selectedOption.value
          : ""
      })
    }
    required
  />
</div>

                  <div className='gap-2 d-flex justify-content-center mt-4'>

                    <button type="submit" className='btn btn-success w-10'>
                      {isEditMode ? "Update" : "Save"}
                    </button>
                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                      setShowForm(false);
                      setIsEditMode(false);
                      resetForm();
                    }}>
                      Cancel
                    </button>
                  </div>

                </div>
              </form>
            </div>
          )}

          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Parent</th>
                 <th scope='col'>HSN Code</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{filteredData.length - idx }</td>
                    <td>  <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>
                  <td> {acc.name} </td>
                  <td> {acc.parent}  </td>
                    <td> {acc.hsn_code} </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>



        
        </div>
      </div>
  </>
  )
}

export default GroupMaster
